module.exports = __webpack_public_path__ + "static/media/6933fb5939cd87752c68648f5db4d540.6933fb59.svg";